import React from "react";
import AOS from "aos";
AOS.init();

const hero = () => {
  return (
    <div className="container">
      <div className="row">
        <div className="col-md-14 text-center">
          <h2>My Resume</h2>
          <div className="space-border"></div>
        </div>
      </div>
      <div className="row gh-5">
        <div className="col-lg-6" data-aos="fade-up" data-aos-once="true">
          <div className="p-4">
            <h3 className="s_border">Experiences</h3>
            <ul className="d_timeline">
              <li className="d_timeline-item">
                <h3 className="d_timeline-title">2019 - now</h3>
                <p className="d_timeline-text">
                  <span className="d_title">Fullstack Developer</span>
                  <span className="d_company">Self-Employed</span>
                  ⚡ Develop visually appealing front end website architecture,
                  including translating designer mock-ups and wireframes into
                  front-end code. <br /> ⚡ Design user interactions on web
                  pages and develop and design RESTful services and APIs.
                  <br /> ⚡ Develop functional databases, applications, and
                  servers to support websites on the back end.
                  <br /> ⚡ Stay abreast of developments in web applications and
                  programming languages. <br /> ⚡ Stay current on cutting edge
                  software approaches, architectures, and vendors. <br /> ⚡
                  Ensure that non-functional requirements, such as security,
                  performance, maintainability, scalability, usability, and
                  reliability are considered when architecting solutions.
                </p>
              </li>

              <li className="d_timeline-item">
                <h3 className="d_timeline-title">2020 - 2021</h3>
                <p className="d_timeline-text">
                  <span className="d_title">
                    Customer Service and Sales Agent
                  </span>
                  <span className="d_company">
                    Teleperformance,Montreal,QC; GEXEL, Montreal,QC
                  </span>
                  ⚡ Answered incoming customer queries and consistently
                  achieved and exceeded sales campaign goals by solving
                  problems, building rapport and turning frustrated clients into
                  repeat customers. <br /> ⚡ Updated information in the
                  customer service database after each customer interaction.
                </p>
              </li>

              <li className="d_timeline-item">
                <h3 className="d_timeline-title">2015 - 2019</h3>
                <p className="d_timeline-text">
                  <span className="d_title">Website Designer(Freelance)</span>
                  <span className="d_company">Self-Employed</span>
                  ⚡ Handled development and management of front-end user
                  interfaces using HTML and CSS. <br />
                  ⚡ Designed graphics, icons and logos. <br />
                  Transferred and deployed webpages to the hosting server,
                  MochaHost,Hostgator.
                  <br />⚡ Set up the Domain Name System (DNS), 007names, at the
                  hosting server, MochaHost to redirect to webpages hosted at
                  MochaHost.
                </p>
              </li>

              <li className="d_timeline-item">
                <h3 className="d_timeline-title">2010 - 2015</h3>
                <p className="d_timeline-text">
                  <span className="d_title">Network Engineer</span>
                  <span className="d_company">
                    Switch-link Technologies Ltd
                  </span>
                  ⚡ Installed all new hardware, systems and software for
                  networks.
                  <br /> ⚡ Installed, configured and maintained network
                  services, equipment and devices. <br />
                  ⚡ Managed all system back-ups and restored protocol. <br />⚡
                  Troubleshot, diagnosed, and documented problems that arose.{" "}
                  <br />
                  ⚡ Diagnosed network problems including hardware, software,
                  power and communications issues. <br />⚡ Collaborated with
                  the team on network development, implementation and
                  maintenance of routers, switches, and firewalls and NAC and
                  WAN optimization.
                </p>
              </li>

              <li className="d_timeline-item">
                <h3 className="d_timeline-title">2007 - 2009</h3>
                <p className="d_timeline-text">
                  <span className="d_title">Product Support Engineer</span>
                  <span className="d_company">Etop NG</span>
                  ⚡ Configured and set up payment software applications on
                  point of sales terminals (POS). <br />⚡ Worked in
                  collaboration with banks to acquire merchants. <br />
                  ⚡ Configured communication links between POS terminals, banks
                  and switching companies (Ex. Interswitch, Visa, MasterCard,
                  eTranzact). <br />
                  ⚡ Led the team in issues and problems resolution.
                  <br />⚡ Provided technical consulting on hardware and
                  software acquisition.
                </p>
              </li>
            </ul>
          </div>
        </div>

        <div className="col-lg-6" data-aos="fade-up" data-aos-once="true">
          <div className="p-4">
            <h3 className="s_border">Education</h3>
            <ul className="d_timeline">
              <li className="d_timeline-item">
                <h3 className="d_timeline-title">Aug 2022</h3>
                <p className="d_timeline-text">
                  <span className="d_title">Cours de Francais</span>
                  <span className="d_company">
                    Centre d’education des adultes Outremont, Montreal, QC.
                  </span>
                </p>
              </li>
              <li className="d_timeline-item">
                <h3 className="d_timeline-title">April 2022</h3>
                <p className="d_timeline-text">
                  <span className="d_title">Diploma </span>
                  <span className="d_company">
                    Concordia University, Montreal, QC.
                  </span>
                  Full-Stack Web Development.
                </p>
              </li>

              <li className="d_timeline-item">
                <h3 className="d_timeline-title">Nov 2006</h3>
                <p className="d_timeline-text">
                  <span className="d_title">Bachelor of Science</span>
                  <span className="d_company">
                    Sikkim Manipal University, Ganktok, India.
                  </span>
                  Applied Information Technology.
                </p>
              </li>

              <li className="d_timeline-item">
                <h3 className="d_timeline-title">2020 - 2023</h3>
                <p className="d_timeline-text">
                  <span className="d_title">Certificates</span>
                  <span className="d_company">Udemy|Coursera </span>
                  Zero To Mastery(ZTM) Web Development,Udemy 2023.
                  <br />
                  Django for Everybody Specialization, Coursera, 2020.
                  <br />
                  Python for Everybody Specialization, Coursera, 2020. <br />
                  Linux Server Management and Security, Coursera, 2020.
                </p>
              </li>
            </ul>
          </div>
        </div>
        <div className="spacer-double"></div>
      </div>
    </div>
  );
};

export default hero;
